import React from 'react';
import PropTypes from 'prop-types';
import { getCouponValue } from '../../../app/Helper/CouponHelper';

function JoinCouponText({ coupons }) {
  const value = getCouponValue(coupons);

  return (
    <span className="newmember_text">
      <span className="newmember_price"> 최대 {value}</span> 할인쿠폰 제공
    </span>
  );
}

JoinCouponText.propType = {
  coupons: PropTypes.shape({}),
};

export default JoinCouponText;
